module.exports = __webpack_public_path__ + "static/media/web-logo-gray.cfff7707.svg";